import { DataGridPro } from '@mui/x-data-grid-pro';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { months } from '../../constants/dates';
import { getDateInWeekDayMonthDateFormat, getEasternTime, getTimeHrMin } from '../../helpers/dateHelpers';
import { SdoMonthlyList } from '../../models/SdoInterface';
import { useSdoAdminReportsProvider } from '../../providers/SdoAdminReportsProvider';
import Loader from '../Loader/Loader';
import './SdoAdminMonthlyReportsTab.scss';
// import { download, getWorkBook } from './MonthlyReportHelper';
// import { useProfile } from '../../providers/Profile';
import { IPADVIEWCONSTANTS } from './UsageReportHelper';

export default function SdoAdminMonthlyReportsTab({ requestlistNoData }) {
    const { t } = useTranslation();
    const sdoAdminReportsContext = useSdoAdminReportsProvider();
    const [isIpadView, setIsIpadView] = useState(false);
    const [sdoMonthlyListData, setSdoMonthlyListData] = useState<SdoMonthlyList[]>([]);
    // const profileContext = useProfile();

    useEffect(() => {
        if (!sdoAdminReportsContext?.sdoMonthlyListData) return;
        setSdoMonthlyListData(sdoAdminReportsContext.sdoMonthlyListData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    window.addEventListener('resize', windowResize);

    function windowResize() {
        const { innerWidth } = window;
        setIsIpadView(innerWidth <= IPADVIEWCONSTANTS.MAXWIDTH && innerWidth > IPADVIEWCONSTANTS.MINWIDTH);
    }

    useEffect(() => {
        if(!sdoAdminReportsContext?.sdoMonthlyReportsData?.sdoSummary) return;
        if(!sdoAdminReportsContext?.sdoMonthlyReportsLoading){
            // The code to download the excel file has been moved to the provider to avoid the download of the same file multiple times
            // download('xlsx', getWorkBook(sdoAdminReportsContext?.sdoMonthlyReportsData, profileContext),sdoAdminReportsContext?.sdoMonthlyReportsData);
            sdoAdminReportsContext.setSdoMonthlyReportsLoading(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sdoAdminReportsContext?.sdoMonthlyReportsData]);

    const handleOpenExcel = (params) => {
        if(!params) return;
        sdoAdminReportsContext?.getSdoMonthlyReportsData({ year: params.year, month: params.month });
    }

    const sdoMonthlyRequestTabsColumns = [
        {
            field: 'year', headerName: 'Year', width: 80, editable: false,
            renderCell: (params) => {
                return (<><p style={{ fontWeight: 600 }}>{params.row.year}</p></>)
            }
        },
        {
            field: 'month', headerName: 'Block Month', width: 125, editable: false,
            renderCell: (params) => {
                return (<><p>{sdoMonthlyListData && sdoMonthlyListData.length === 0 ? '-' : months[params.row.month - 1]}</p></>)
            }
        },
        {
            field: 'submissionClosed', headerName: 'Submission Closed', width: 200, editable: false, hideable: true,
            renderCell: (params) => {
                return (<><p>{sdoMonthlyListData && sdoMonthlyListData.length === 0 ? '-' : `${getDateInWeekDayMonthDateFormat(getEasternTime(params.row.submissionClosed))} ${getTimeHrMin(getEasternTime(params.row.submissionClosed))}`}</p></>)
            }
        },
        {
            field: 'publishedOn', headerName: 'Published On', width: 247, editable: false,
            renderCell: (params) => {
                return (<><p>{sdoMonthlyListData && sdoMonthlyListData.length === 0 ? 'Not available yet' : `${getDateInWeekDayMonthDateFormat(getEasternTime(params.row.publishedOn)) + ","} ${getEasternTime(params.row.publishedOn).getFullYear()} ${getTimeHrMin(getEasternTime(params.row.publishedOn))}`}</p></>)
            }
        },
        {
            field: 'requests', headerName: 'SDO Requests', width: isIpadView ? 105 : 141, editable: false,
            renderCell: (params) => {
                return (<><p className='sdo-monthly-req-tabs__sdoRequests'>{sdoMonthlyListData && sdoMonthlyListData.length === 0 ? '-' : params.row.requests}</p></>)
            }
        },
        {
            field: 'approved', headerName: 'SDOs Approved', width: isIpadView ? 105 : 141, editable: false,
            renderCell: (params) => {
                return (<><p style={{ textAlign: "center" }} className='sdo-monthly-req-tabs__sdoApproved'>{sdoMonthlyListData && sdoMonthlyListData.length === 0 ? '-' : params.row.approved}</p></>)
            }
        },
        {
            field: 'declined', headerName: 'SDOs Declined', width: isIpadView ? 105 : 138, editable: false,
            renderCell: (params) => {
                return (<><p style={{ textAlign: "center" }} className='sdo-monthly-req-tabs__sdoDeclined'>{sdoMonthlyListData && sdoMonthlyListData.length === 0 ? '-' : params.row.declined}</p></>)
            }
        },
        {
            field: 'actions',
            headerName: ' ',
            width: 200,
            sortable: false,
            disableClickEventBubbling: true,
            renderCell: (params) => {
                return (
                    <>
                        { (sdoMonthlyListData && sdoMonthlyListData.length === 0)  ? '' : <div className="sdo-monthly-req-tabs__actions" onClick={() => handleOpenExcel(params.row)}> <i className="icon-Export-Icon" />{t('specialDayOffAdmin.sdoAdminTabs.exportReport')}</div> }
                    </>                        
                );
            }
        }
    ];

    return (
        sdoAdminReportsContext.sdoMonthlyListLoading ? <Loader /> : (
        <div className='sdo-monthly-req-tabs__container'>
            <p className='sdo-monthly-req-tabs__title'>{t("specialDayOffAdmin.sdoAdminTabs.SdoMonthlyReports")}</p>
            <div className='sdo-monthly-req-tabs__table'>
                {sdoMonthlyListData && sdoMonthlyListData.length > 0 ?
                    <DataGridPro
                        autoHeight
                        disableColumnMenu
                        //disableSelectionOnClick
                        //disableExtendRowFullWidth={true}
                        rows={sdoMonthlyListData}
                        columns={sdoMonthlyRequestTabsColumns}
                        columnVisibilityModel={{ submissionClosed: !isIpadView }}
                        disableRowSelectionOnClick
                        hideFooterPagination
                    /> :
                    <DataGridPro
                        autoHeight
                        disableColumnMenu
                        //disableSelectionOnClick
                        //disableExtendRowFullWidth={true}
                        rows={requestlistNoData}
                        columns={sdoMonthlyRequestTabsColumns}
                        hideFooterPagination
                        disableRowSelectionOnClick
                    />
                }
            </div>
        </div>
        )
    );
}